import {ThemeMode, useThemeSettings} from '@hconnect/uikit'
import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useMediaQuery} from '@mui/material'
import {useEffect} from 'react'

export const HPRODUCE_THEME_LIGHT: Theme = 'ThemeLightBlueGrey'
export const HPRODUCE_THEME_DARK: Theme = 'ThemeDarkBlue'

export const THEME_MODE_STORAGE_KEY = 'hproduce-suite-theme-mode'

const isSupportedThemeMode = (value: string | null): value is ThemeMode =>
  value === ThemeMode.Light || value === ThemeMode.Dark || value === ThemeMode.Device

export const getStoredThemeMode = (): ThemeMode => {
  const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY)
  return isSupportedThemeMode(stored) ? stored : ThemeMode.Light
}

export const persistThemeMode = (mode: ThemeMode): void =>
  localStorage.setItem(THEME_MODE_STORAGE_KEY, mode)

/**
 * Keeps the Fundamental (shell) theme in sync with the MUI theme mode from
 * `ThemeSettingsProvider`, so the shell and features switch light/dark together.
 */
export const useInitializeFundamentalTheme = () => {
  const {theme: fundamental} = useFundamentalContext()
  const {themeMode} = useThemeSettings()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  useEffect(() => {
    const resolvedMode =
      themeMode === ThemeMode.Device
        ? prefersDarkMode
          ? ThemeMode.Dark
          : ThemeMode.Light
        : themeMode
    const targetTheme = resolvedMode === ThemeMode.Dark ? HPRODUCE_THEME_DARK : HPRODUCE_THEME_LIGHT

    if (fundamental.currentTheme !== targetTheme) {
      fundamental.updateTheme(targetTheme)
    }
  }, [fundamental, themeMode, prefersDarkMode])
}
